import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, fontSize } = theme.tokens;
  return {
    page: {
      ...theme.mixins.page,
      gap: 24
    },
    productsWrap: {
      minHeight: 600,
      marginTop: 8
    },
    // cancel the cells' side padding so the grid lines up with the gutter
    grid: {
      width: "calc(100% + 20px)",
      margin: "0 -10px",
      [theme.media.phone]: {
        width: "calc(100% + 12px)",
        margin: "0 -6px"
      }
    },
    seoContent: {
      marginTop: 24,
      paddingTop: 24,
      boxShadow: `inset 0 1px 0 ${color.line}`,
      fontSize: fontSize.ui,
      lineHeight: 1.6,
      color: color.muted,
      "& h1, & h2, & h3": {
        color: color.ink,
        fontSize: fontSize.h3,
        fontWeight: 800,
        margin: "16px 0 8px"
      },
      "& a": { color: color.ink }
    }
  };
});

export default withCustomStyles;
